document.addEventListener("DOMContentLoaded", (event) => {
  if (BSS_B2B && window.location.pathname === "/cart") {
    setTimeout(() => {
      BSS_B2B.cp.changeProductPrice(
        JSON.parse($("#bss-b2b-store-data").html()),
        false,
        false
      );
    }, 2000);
  }
  if (BSS_B2B) {
    const targetNode = document.querySelector(
      ".header-cart.action-area__link.has-cart-count"
    );
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target.className.includes("show-mini-cart")
        ) {
          BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
          BSS_B2B.cart.fixer(
            JSON.parse($("#bss-b2b-store-data").html()),
            false,
            true
          );
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});
